import { render, staticRenderFns } from "./wiki-config-settings.vue?vue&type=template&id=c7f5ef94&"
import script from "./wiki-config-settings.vue?vue&type=script&lang=ts&"
export * from "./wiki-config-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports